import './App.css';
import React from 'react';
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Admin from './Pages/Admin';
import Userpage from './Pages/Userpage';
import Loginpg from './Pages/Login';
import PrivateRoute from './Protected';

const App = () =>{
  
  return (
    <Router>
      <div className="appcontainer">
          <Routes>
            <Route exact path="/" element={<Userpage />} /> 
            <Route path="/login" element={<Loginpg />} />
            <Route path="/" element={<PrivateRoute />}>
              <Route path="/documentupload" element={<Admin/>}/>
            </Route>
          </Routes>
      </div>
    </Router>
  );
}

export default App;
